module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('shopDecoration', {
    attrs: {
      "id": _vm.current
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3edcc447", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3edcc447"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/marketing/shopDecoration.vue
// module id = 2653
// module chunks = 0